import { MatsForAccount } from "@mezo/api"
import { useQuery } from "@tanstack/react-query"

import {
  initialMats,
  resetMats,
  selectWalletAddress,
  setMats,
  setMatsLoading,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { PORTAL_API_URL_V2 } from "#/shared/constants"

const useFetchMats = () => {
  const address = useDappSelector(selectWalletAddress)
  const dispatch = useDappDispatch()

  const { refetch: fetchMats } = useQuery<MatsForAccount>({
    enabled: !!address,
    queryKey: ["matsForAccount"],
    queryFn: async () => {
      dispatch(setMatsLoading(true))

      const response = await fetch(
        `${PORTAL_API_URL_V2}account/${address}/mats`,
        { credentials: "include" },
      )

      if (!response.ok) {
        dispatch(resetMats())
        return initialMats
      }

      const matsForAccount = await response.json<MatsForAccount>()

      // Adding nullish coallesing operator to make sure we are passing
      // correct data to redux
      dispatch(
        setMats({
          totalMats: matsForAccount.totalMats ?? 0,
          inactiveMats: matsForAccount.inactiveMats ?? 0,
          matsActivated: matsForAccount.matsActivated ?? false,
        }),
      )

      dispatch(setMatsLoading(false))

      return matsForAccount
    },
  })

  return { fetchMats }
}

export default useFetchMats
